<article [ngClass]="valueType === 'image' ? 'info-box-image dead-center mb-4' : 'info-box'">
  <span class="overline-list custom-color-tertiary mb-1" *ngIf="valueType !== 'image'">{{ isTranslatable ? (label | translate) : label }}</span>

  <ng-container [ngSwitch]="valueType">
    <div class="color-light" *ngSwitchCase="'text'">
      {{ value }}
    </div>
    <div class="text-xl color-light" *ngSwitchCase="'currency'">
      <strong>{{ valueOrMax | currency:'EUR':'symbol' }}</strong>
    </div>
  </ng-container>

  <ng-container [ngSwitch]="valueType">
    <div class="color-light" *ngSwitchCase="'currency'">
      BCP {{ businessCardPrice | number:'1.2-2'}}
    </div>
  </ng-container>
</article>
